import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
   const { colors } = useContextState()
  return {
    gestionZoneGrid: {
      borderRight: "1px solid #E4E4E4",
      paddingRight: 2
    },
    gestioneZoneBox: {
      display: "flex",
      gap: 2,
      flexDirection: "column"
    },
    categoryAndSubCategoryGrid: {
      borderRight: { xs: 'none', sm: 'none', xl: '1px solid #E4E4E4' },
      paddingRight: 2,
    },
    btnsContainer: {
      marginTop: {
        sm: 2,
        xl: 15
      },
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    btnBack: {
      textTransform: "none",
      padding: 0,
      backgroundColor: "transparent",
      color: "primary.main",
      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
    },
    categoriesSelected: {
      backgroundColor: "#f9f9fc",
      padding: 2,
      minHeight: "120px",
      borderRadius: 2,
    },
    containerNoCategories: {
      display: 'flex',
      gap:1,
      alignItems: 'center',
      color: colors.color32,
      '& .MuiSvgIcon-root':{
        fontSize:'35px'
      }
    }
  }
}